import React, { useMemo } from 'react'

import { useAuthInfo } from '@sweetauth/core'

import { useNavigationOptions } from '@/components/common/Sidebar/hooks'
import CommonNavbar from '@/components/layouts/common/Navbar'

import { usePathname } from '@/hooks/common/usePathname'
import { useActiveOrg } from '@/hooks/organization/useActiveOrg'
import { useActiveOrgId } from '@/hooks/organization/useActiveOrgId'

const Navbar: React.FC = () => {
  const { activeOrgId } = useActiveOrgId()
  const { activeOrg: organization, isLoading } = useActiveOrg()
  const { navigationOptions } = useNavigationOptions()
  const { user } = useAuthInfo()

  const pathname = usePathname()
  const activeTab = useMemo(
    () =>
      navigationOptions.find((option) =>
        (pathname ?? '').includes(option.href),
      ),
    [navigationOptions, pathname],
  )

  const orgIsLoading = useMemo(() => {
    // if the user is not logged in, the org is not loading
    if (user === null) {
      return false
    }
    return activeOrgId === '' || isLoading || organization === undefined
  }, [activeOrgId, isLoading, organization, user])

  const breadcrumbs = useMemo(() => {
    if (organization === undefined || activeOrgId === '') {
      return []
    }
    if (activeTab) {
      return [
        { name: organization.name, href: `/orgs/${activeOrgId}/profile` },
        { name: activeTab.name },
      ]
    }
    return [{ name: organization.name, href: `/orgs/${activeOrgId}/profile` }]
  }, [activeOrgId, activeTab, organization])

  return <CommonNavbar isLoading={orgIsLoading} breadcrumbs={breadcrumbs} />
}

export default Navbar
